// Pure helpers for the Security page (backups / audit logs).

export const sumBackupStats = (stats) =>
  Object.values(stats || {}).reduce((a, b) => a + (typeof b === 'number' ? b : 0), 0);

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleString();
};

export const getActionBadgeColor = (action) => {
  if (action.includes('FAILED') || action.includes('DELETE')) return 'bg-red-100 text-red-800';
  if (action.includes('CREATE') || action.includes('LOGIN')) return 'bg-green-100 text-green-800';
  if (action.includes('UPDATE') || action.includes('CHANGE')) return 'bg-blue-100 text-blue-800';
  return 'bg-gray-100 text-gray-800';
};
